var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "check"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1353_3666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1353_3666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M6.38367 11.7167C6.29478 11.7167 6.20867 11.7 6.12533 11.6667C6.042 11.6333 5.96144 11.5778 5.88367 11.5L3.067 8.68332C2.93367 8.54999 2.86978 8.38055 2.87533 8.17499C2.88089 7.96944 2.95033 7.79999 3.08367 7.66666C3.217 7.53333 3.38367 7.46666 3.58367 7.46666C3.78367 7.46666 3.95033 7.53333 4.08367 7.66666L6.417 9.99999L11.9337 4.48333C12.067 4.34999 12.2309 4.28333 12.4253 4.28333C12.6198 4.28333 12.7837 4.34999 12.917 4.48333C13.0503 4.61666 13.117 4.78055 13.117 4.97499C13.117 5.16944 13.0503 5.33333 12.917 5.46666L6.88367 11.5C6.80589 11.5778 6.72533 11.6333 6.642 11.6667C6.55867 11.7 6.47256 11.7167 6.38367 11.7167Z",
    fill: "#0047CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.1e4ab5a906e14207a5d844c8e09d9e7a.svg";
export { ForwardRef as ReactComponent };